var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentText({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74984 13.2707H5.24984C2.08234 13.2707 0.729004 11.9173 0.729004 8.74984V5.24984C0.729004 2.08234 2.08234 0.729004 5.24984 0.729004H8.1665C8.40567 0.729004 8.604 0.927337 8.604 1.1665C8.604 1.40567 8.40567 1.604 8.1665 1.604H5.24984C2.56067 1.604 1.604 2.56067 1.604 5.24984V8.74984C1.604 11.439 2.56067 12.3957 5.24984 12.3957H8.74984C11.439 12.3957 12.3957 11.439 12.3957 8.74984V5.83317C12.3957 5.594 12.594 5.39567 12.8332 5.39567C13.0723 5.39567 13.2707 5.594 13.2707 5.83317V8.74984C13.2707 11.9173 11.9173 13.2707 8.74984 13.2707Z",
    fill: "#3C7AF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8332 6.27079H10.4998C8.50484 6.27079 7.729 5.49495 7.729 3.49995V1.16662C7.729 0.991619 7.834 0.828286 7.99734 0.764119C8.16067 0.694119 8.34734 0.734953 8.47567 0.857453L13.1423 5.52412C13.2648 5.64662 13.3057 5.83912 13.2357 6.00245C13.1657 6.16579 13.0082 6.27079 12.8332 6.27079ZM8.604 2.22245V3.49995C8.604 5.00495 8.99484 5.39579 10.4998 5.39579H11.7773L8.604 2.22245Z",
    fill: "#3C7AF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5835 8.021H4.0835C3.84433 8.021 3.646 7.82266 3.646 7.5835C3.646 7.34433 3.84433 7.146 4.0835 7.146H7.5835C7.82266 7.146 8.021 7.34433 8.021 7.5835C8.021 7.82266 7.82266 8.021 7.5835 8.021Z",
    fill: "#3C7AF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41683 10.354H4.0835C3.84433 10.354 3.646 10.1557 3.646 9.9165C3.646 9.67734 3.84433 9.479 4.0835 9.479H6.41683C6.656 9.479 6.85433 9.67734 6.85433 9.9165C6.85433 10.1557 6.656 10.354 6.41683 10.354Z",
    fill: "#3C7AF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentText);
export default __webpack_public_path__ + "static/media/document-text.deffc55aee11d05183eecdd7d44472ab.svg";
export { ForwardRef as ReactComponent };